import { Component } from '../ecs/Component.js';

export class Chest extends Component {
  /**
   * @param {object} [options]
   * @param {number} [options.weaponChance] 0..1 chance to grant a weapon instead of ammo.
   * @param {number} [options.ammoMagazines] Full magazines added on an ammo reward.
   */
  constructor({ weaponChance = 0.5, ammoMagazines = 2, index = -1 } = {}) {
    super();
    /** @type {boolean} */
    this.opened = false;
    /** @type {number} */
    this.weaponChance = Math.min(1, Math.max(0, weaponChance));
    /** @type {number} */
    this.ammoMagazines = Math.max(1, ammoMagazines);
    /** @type {number} Instance slot in the dungeon builder's chest meshes, -1 if none. */
    this.index = index;
  }
}
